import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IAuthErrorProps {
  onClick(): void;
}

export const AuthError: React.VFC<IAuthErrorProps> = ({ onClick }) => {
  return (
    <div className={styles['container']} data-testid="offers_history_auth_error">
      <UIText1>
        <button className={styles['pseudolink']} onClick={onClick}>
          Войдите
        </button>
        , чтобы просматривать снятые с публикации объявления
      </UIText1>
    </div>
  );
};
